
    import Vue from 'vue';
    import CUPEService from '@/apps/shared/services/cupe-service';
    import MailService from '@/apps/shared/services/email-service';
    import CRMCotizadorWebService from '@/apps/shared/services/crm-service';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper';
    import ParamCotizService from '@/apps/shared/services/ParamCotizOfSession-service';
    import ContractFinish from "@/apps/shared/components/ContractFinish.vue";
    import { TitleAndPromotionsDetails } from '@/apps/shared/models/titleAndPromotionsDetails';

    interface payload {
        productId: number;
        pricingId: number;
        policyOwner: {
            firstName: string;
            lastName: string;
            documentNumber: string;
            email: string;
        };
        healthQuotation: {
            effectDate: string;
            expirationDate: string;
        };
        planSelected: {
            planDescription: string;
            premioMensual: number;
            pricingId: string;
        };
        leadId: string;
        selectedPricingId: string;
        clientData: {
            firstName: string;
            lastName: string;
            documentNumber: string;
            areaCode: string;
            telephone: string;
            email: string;
        };
        dataTabHome: {
            selectedLocality: {
                name: string;
                zipCode: string;
            };
        };
        planDescription: string;
        referente: string;
        medium: string;
        pas: string;
        rutaAlternativa: string;
    }

    export default Vue.extend({
        components: {
            ContractFinish
        },
        name: 'healthMaxFinalPayment-view',
        data() {
            return {
                titleAndPromotionDetails: {
                    icon: {
                        src: '/icons/check.png',
                    },
                } as TitleAndPromotionsDetails,
                payload: null as payload | null,
            }
        },
        methods: {
            async pageCustomization() {
                const defaultTitle = 'Salud Segura Max';
                const actualPath = '/salud-segura-max';
                // Llamamos al helper que se encarga de toda la lógica
                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, null, null);
                    const title = this.$store.getters.getWebSaleData?.pageCustomization?.navbar?.title ?? '';
                    this.payload.pas = title === defaultTitle ? null : title;
                }
                catch (error) {
                    const statusCode = error.response.status;
                    this.Bus.$emit(
                        'show-service-fail',
                        statusCode,
                        [() => this.pageCustomization()]);
                }
            },

            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'DefaultSafeHealthMaxGTMInfo';
                this.Bus.$emit('updateByProductGoogleAnalytics', productGtmName);
            },

            fetchSessionPayload(guid: string): Promise<void> {
                return ParamCotizService.getParamCotiz(guid)
                    .then(resp => {
                        if (!resp.hasData || !resp.data) {
                            console.warn(resp.message);
                            throw new Error(resp.message);
                        }
                        this.payload = JSON.parse(resp.data) as payload;
                    });
            },

            getFilePath() {
                if (this.payload.rutaAlternativa) {
                    this.$router.push(this.payload.rutaAlternativa);
                }
                else {
                    this.$router.push({ name: 'healthMaxHome-view' });
                }                
            },

            getMailValues() {
                const formatDate = (dateString: string): string => {
                    const date = new Date(dateString);
                    const day = date.getDate().toString().padStart(2, '0');
                    const month = (date.getMonth() + 1).toString().padStart(2, '0');
                    const year = date.getFullYear().toString();
                    return `${day}/${month}/${year}`;
                };
                let clientData = this.payload.policyOwner;
                let nombreCliente = clientData.firstName.toLowerCase().split(' ')
                let firstName = nombreCliente[0].charAt(0).toUpperCase() + nombreCliente[0].substring(1);
                let planData = this.payload.healthQuotation;
                let planDataSelected = this.payload.planSelected;
                let effectDate = formatDate(planData.effectDate);
                let expirationDate = formatDate(planData.expirationDate);
                let mailValues = JSON.stringify({
                    parameters: [
                        {
                            name: "@ReportCode",
                            value: "25"
                        },
                        {
                            name: "@contratante",
                            value: firstName.toString()
                        },
                        {
                            name: "@nombrePlan",
                            value: planDataSelected.planDescription.toString()
                        },
                        {
                            name: "@vigenciaDesde",
                            value: effectDate
                        },
                        {
                            name: "@vigenciaHasta",
                            value: expirationDate
                        },
                        {
                            name: "@costoMensual",
                            value: planDataSelected.premioMensual.toFixed(2).replace(".", ",").toString()
                        }
                    ],
                    to: clientData.email,
                    from: "cotizador@sancorseguros.com",
                    productId: 321
                });
                return mailValues;
            },


            async addFinishQuotation() {
                sessionStorage.setItem("ExitOrContinueModal", "true");
                NF.UI.Page.block();
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                this.leadId = this.payload.leadId;
                this.externalIdentifier = this.payload.selectedPricingId;
                let planData = this.payload.planSelected;
                let clientData = this.payload.clientData;
                let DataHome = this.payload.dataTabHome;
                let localidad = (DataHome.selectedLocality.name + " " + DataHome.selectedLocality.zipCode).toString();
                let planDescription = this.payload.planDescription;
                let ramo = "Salud Segura Max";

                const eventData = {
                    'pas': this.payload.pas,
                    'email': this.payload.policyOwner.email,
                    'product': 'salud',
                    'event': 'cotizador-salud-venta-completa',
                    'value': parseInt(planData.premioMensual),
                    'referente': this.payload.referente,
                    'medio': this.payload.medium
                };

                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                window.globalThis.dataLayer.push(eventData);

                const customWindow = window as typeof window & {
                    _qsie?: Array<typeof eventData>;
                };

                customWindow._qsie ??= [];
                customWindow._qsie.push(eventData);

                await CUPEService.Finish(parseInt(this.externalIdentifier), 321, clientData.lastName, clientData.documentNumber, localidad, clientData.email, clientData.firstName, planData.pricingId.toString(), parseInt(planData.premioMensual), planData.planDescription, ramo, clientData.areaCode, clientData.telephone).then(async (FinishResult) => {
                    if (FinishResult) {
                        CRMCotizadorWebService.CreateOrEditLead(this.leadId, null, location.href, null, null, 321, true, "7", null, null, null);
                        //ENVIO DE EMAIL
                        await MailService.sendMail(this.getMailValues()).then(response => {
                            if (response.result) {
                                NF.Notification.show({
                                    type: NF.Notification.Type.SUCCESS,
                                    title: 'Mail Enviado',
                                    content: 'Mail enviado exitosamente.',
                                    position: NF.Notification.Positions.TOP_RIGHT,
                                    clickClose: true,
                                    autoHideDelay: 10000,
                                });
                                NF.UI.Page.unblock();
                            } else if (response.result == false) {
                                NF.Notification.show({
                                    type: NF.Notification.Type.ERROR,
                                    title: 'Error',
                                    content: 'Se produjo un error inesperado.',
                                    position: NF.Notification.Positions.TOP_RIGHT,
                                    clickClose: true,
                                    autoHideDelay: 10000,
                                });
                                NF.UI.Page.unblock();
                            } else {
                                NF.UI.Page.unblock();
                            }
                        });
                    }
                    else {
                        const eventData = {
                            'pas': this.payload.pas,
                            'email': this.payload.policyOwner.email,
                            'product': 'salud',
                            'event': 'errorServidor',
                            'paso': 'cotizador-salud-venta-completa',
                            'referente': this.payload.referente,
                            'medio': this.payload.medium
                        };

                        window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                        window.globalThis.dataLayer.push(eventData);

                        const customWindow = window as typeof window & {
                            _qsie?: Array<typeof eventData>;
                        };

                        customWindow._qsie ??= [];
                        customWindow._qsie.push(eventData);
                    }
                });
            }
        },
        async mounted() {
            try {
                NF.UI.Page.block();

                const guid = sessionStorage.getItem('ParamId');
                if (!guid) {
                    console.error('No hay ParamId en sessionStorage');
                    return;
                }
                const parallelPromises = [
                    this.fetchSessionPayload(guid),
                    this.pageCustomization(),
                    this.updateByProductGoogleAnalytics(),

                ];

                await Promise.all([
                    ...parallelPromises,
                ]);

                await this.addFinishQuotation();

            } finally {
                NF.UI.Page.unblock();
            }
        },
    });
